import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { StorageService } from '@app/core/services/storage.service';
import { CoreAPIService } from '@app/core/services/core-api.service';
import { first } from 'rxjs/operators';

@Component({
	selector: 'cng-auth-pass-through',
	template: '',
})
export class AuthenticatePassThroughComponent {
	success_path: string;
	failed_path: string;
	/**
	 * Constructs class and injects dependencies.
	 * Used for 'magic links' sent to customers.
	 *
	 * @param {CoreAPIService} core_api_service
	 * @param {ActivatedRoute} activated_route
	 * @param {StorageService} storage_service
	 * @param {Router} router
	 */
	constructor(
		private core_api_service: CoreAPIService,
		private activated_route: ActivatedRoute,
		private storage_service: StorageService,
		private router: Router
	) {
		this.activated_route.data.pipe(first()).subscribe((data) => {
			this.success_path = data.success_path;
			this.failed_path = data.failed_path;
		});

		this.activated_route.params.pipe(first()).subscribe((params: Params) => {
			const enquiry_hash: string = params['enquiry_hash'];
			const access_code: string = params['access_code'];

			const body: any = {
				pin: access_code,
			};

			this.core_api_service
				.verify(enquiry_hash, body)
				.pipe(first())
				.subscribe((response) => {
					if (response.status !== 200) {
						this.router.navigate([this.failed_path.replace(':enquiry_hash', enquiry_hash)]);
					} else {
						this.storage_service.setItem('token-' + enquiry_hash, response.body.token);
						this.router.navigate([this.success_path.replace(':enquiry_hash', enquiry_hash)]);
					}
				});
		});
	}
}
